import React, { useEffect, useContext } from 'react'
import { Grid, Typography, Container, useMediaQuery, Box, CssBaseline } from '@mui/material';
import { useNavigate,useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';
import { useTheme,styled } from '@mui/material/styles';



import Row1 from './Row1';
import Row2 from './Row2';
import Row3 from './Row3';



const gridTemplateLargeScreens = `
  "a b c"
  "a b c"
  "a b c"
  "a b f"
  "d e f"
  "d e f"
  "d h i"
  "g h i"
  "g h j"
  "g h j"
`;
const gridTemplateSmallScreens = `
  "a"
  "a"
  "a"
  "a"
  "b"
  "b"
  "b"
  "b"
  "c"
  "c"
  "c"
  "d"
  "d"
  "d"
  "e"
  "e"
  "f"
  "f"
  "f"
  "g"
  "g"
  "g"
  "h"
  "h"
  "h"
  "h"
  "i"
  "i"
  "j"
  "j"
`;

const BizzBoard = () => {
 
  const navigate = useNavigate();
 
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const data = location.state?.data;
  
  return (
    <div style={{ background: theme.palette.background.default, height: '100vh' }}>

      <CssBaseline />
      <Navbar />
      <Grid container style={{ height: 'calc(100vh - 64px)' }}> {/* Adjusted height */}
        {!isSmallScreen && (
          <Grid item xs={2} style={{ height: '100%' }}>
            <Sidebar />
          </Grid>
        )}
        <Grid item xs={12} sm={10} style={{ height: '100%', overflowY: 'auto',padding:'10px',background:theme.palette.black[100]}}>
          <Box
            width="100%"
            height="100%"
            display="grid"
            gap="1.5rem"
            sx={
              !isSmallScreen
                ? {
                  gridTemplateColumns: "repeat(3, minmax(370px, 1fr))",
                  gridTemplateRows: "repeat(10, minmax(60px, 1fr))",
                  gridTemplateAreas: gridTemplateLargeScreens
                  
                }
                : {
                  gridAutoColumns: "1fr",
                  gridAutoRows: "80px",
                  gridTemplateAreas: gridTemplateSmallScreens
                  
                }
            }
          >
            <Row1 revenue_expenses_data={data}/>
            <Row2 expenses_data={data}/>
            <Row3 product_data={data}/>
          </Box>
        </Grid>

      </Grid>

    </div>
  );

}

export default BizzBoard